<template>
  <div class="flex flex-wrap items-start gap-8">
    <TeamFields class="flex-[1_1_24rem]" :sso-only="ssoOnlyRef" />
    <aside class="flex min-w-0 flex-[1_1_17.5rem] flex-col gap-3 rounded-lg bg-muted p-5">
      <h2 class="text-base font-semibold">{{ t('admin.setup.team.about.title') }}</h2>
      <ul class="flex flex-col gap-2.5 text-sm leading-normal">
        <li v-for="key in ABOUT_ITEMS" :key="key" class="flex gap-2">
          <CheckIcon class="mt-0.5 size-4 shrink-0 text-success" aria-hidden="true" />
          <span>{{ t(`admin.setup.team.about.${key}`) }}</span>
        </li>
        <li class="flex gap-2">
          <EyeOffIcon class="mt-0.5 size-4 shrink-0 text-muted-foreground" aria-hidden="true" />
          <span>{{ t('admin.setup.team.about.hidden') }}</span>
        </li>
      </ul>
      <p class="border-t pt-3 text-sm leading-normal text-muted-foreground">
        {{ t('admin.setup.team.about.oneProgram') }}
      </p>
    </aside>
  </div>
</template>

<script setup lang="ts">
import { CheckIcon, EyeOffIcon } from 'lucide-vue-next'
import { computed } from 'vue'

import TeamFields from '@/features/admin/platform-setup/components/steps/team-fields.vue'
import { usePlatformSetup } from '@/features/admin/platform-setup/hooks/use-platform-setup.hook'
import { useI18n } from '@/lib/i18n'

const ABOUT_ITEMS = ['allPrograms', 'settings', 'impersonate'] as const

const { t } = useI18n()
const { savedRef } = usePlatformSetup()
const ssoOnlyRef = computed(() => savedRef.value.EMAIL_LOGIN_ENABLED === 'false')
</script>
